import { render, staticRenderFns } from "./CoreWysiwyg.vue?vue&type=template&id=367d9e8d&lang=pug"
import script from "./CoreWysiwyg.vue?vue&type=script&lang=ts"
export * from "./CoreWysiwyg.vue?vue&type=script&lang=ts"
import style0 from "./CoreWysiwyg.vue?vue&type=style&index=0&id=367d9e8d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports